var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoStandardView = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.727273 0.5C0.325611 0.5 0 0.825611 0 1.22727V7.04545C0 7.44712 0.325611 7.77273 0.727273 7.77273H6.90909C7.31075 7.77273 7.63636 7.44712 7.63636 7.04545V1.22727C7.63636 0.825611 7.31075 0.5 6.90909 0.5H0.727273Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.727273 8.5C0.325611 8.5 0 8.82561 0 9.22727V15.0455C0 15.4471 0.325611 15.7727 0.727273 15.7727H6.90909C7.31075 15.7727 7.63636 15.4471 7.63636 15.0455V9.22727C7.63636 8.82561 7.31075 8.5 6.90909 8.5H0.727273Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09104 0.5C8.68938 0.5 8.36377 0.825611 8.36377 1.22727V7.04545C8.36377 7.44712 8.68938 7.77273 9.09104 7.77273H15.2729C15.6745 7.77273 16.0001 7.44712 16.0001 7.04545V1.22727C16.0001 0.825611 15.6745 0.5 15.2729 0.5H9.09104Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09104 8.5C8.68938 8.5 8.36377 8.82561 8.36377 9.22727V15.0455C8.36377 15.4471 8.68938 15.7727 9.09104 15.7727H15.2729C15.6745 15.7727 16.0001 15.4471 16.0001 15.0455V9.22727C16.0001 8.82561 15.6745 8.5 15.2729 8.5H9.09104Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoStandardView);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_standard_view.34181050c84eb0141b77f8cb63bc43a7.svg";